/*
 * We recommend using the merged theme if you want to override our core theme.
 * This means you can use our core theme and override it with your own customizations.
 * Write your overrides in the userTheme object in this file.
 * The userTheme object is merged with the coreTheme object within this file.
 * Export this file and import it in the `@components/theme/index.tsx` file to use the merged theme.
 */

// MUI Imports
import { deepmerge } from '@mui/utils';
import type { Theme } from '@mui/material/styles';

// Type Imports
import type { Settings } from '@core/contexts/settingsContext';
import type { SystemMode } from '@core/types';

// Core Theme Imports
import coreTheme from '@core/theme';
import { COLORS, DARK_COLORS } from '@/libs/styles/color.style';

const mergedTheme = (
    settings: Settings,
    mode: SystemMode,
    direction: Theme['direction']
) => {
    // Vars
    const userTheme = {
        // Write your overrides here.
        colorSchemes: {
            light: {
                palette: {
                    primary: {
                        light: COLORS.primary.light,
                        main: COLORS.primary.main,
                        dark: COLORS.primary.dark,
                        containedHover: COLORS.primary.containedHover,
                        outlinedHover: COLORS.primary.outlinedHover,
                        outlinedResting: COLORS.primary.outlinedResting,
                    },
                    secondary: {
                        light: COLORS.secondary.light,
                        main: COLORS.secondary.main,
                        dark: COLORS.secondary.dark,
                    },
                },
            },
            dark: {
                palette: {
                    primary: {
                        light: DARK_COLORS.primary.light,
                        main: DARK_COLORS.contrastText,
                        dark: DARK_COLORS.primary.dark,
                        containedHover: DARK_COLORS.primary.containedHover,
                        outlinedHover: DARK_COLORS.primary.outlinedHover,
                        outlinedResting: DARK_COLORS.primary.outlinedResting,
                    },
                    secondary: {
                        light: COLORS.secondary.light,
                        main: COLORS.secondary.main,
                        dark: COLORS.secondary.dark,
                    },
                },
            },
        },
    } as Theme;

    return deepmerge(coreTheme(settings, mode, direction), userTheme);
};

export default mergedTheme;
